import useCrud from 'hooks/useCrud';
import { packageList, packageListV2 } from 'services/api/pay';
import { isQuickChat } from 'productLine';

function usePackage() {
  return useCrud({
    readList: packageList,
  });
}

export function usePackageV2(orgId: number | undefined, orderAction: Pay.OrderType) {
  return useCrud({
    read: () => {
      if (!orgId) {
        throw new Error('orgId empty');
      }
      return packageListV2(orgId, orderAction);
    },
  });
}

export function converV2PackageToV1(rst: Pay.PackageInfoV2) {
  const packInfo: Pay.Package = {
    packageName: '乐聊服务工作台',
    packageType: isQuickChat ? 3 : 1,
    packageDetails: [],
  };
  const { recommendPackageId, recommendDurationId } = rst.recommendData;
  rst.packageData.forEach((v) => {
    v.durationDesc.forEach((d) => {
      packInfo.packageDetails.push({
        accountInfo: {
          accountNum: v.accountNum,
          recommendStatus: recommendPackageId === v.id ? 2 : 1,
        },
        durationInfo: {
          durationNum: d.durationNum,
          recommendStatus: recommendDurationId === v.id ? 2 : 1,
        },
        durationDescribe: {
          uS: d.name,
          cN: d.name,
        },
        originalPrice: d.price,
        actualPrice: d.price,
      });
    });
  });
  return packInfo;
}

export default usePackage;
